/* eslint-disable import/prefer-default-export */
import store from '@/store';
import router from '@/router';

import Config from '../Config';

export async function useSelfieParcelexFallback({ frontendOnboardingVersion, error }) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const query = Object.fromEntries(urlSearchParams.entries());

  let onboardingId = store.getters['onboarding/onboardingId'];

  if (frontendOnboardingVersion === 'minified') {
    onboardingId = store.getters['minifiedOnboarding/onboardingId'];
  } if (frontendOnboardingVersion === 'v2') {
    onboardingId = store.getters['onboardingV2/onboardingId'];
  }

  const token = store.getters['auth/token'];

  let totalValue = store.getters['onboarding/totalValue'];

  if (frontendOnboardingVersion === 'minified') {
    totalValue = store.getters['minifiedOnboarding/totalValue'];
  } if (frontendOnboardingVersion === 'v2') {
    totalValue = store.getters['onboardingV2/totalValue'];
  }

  const facetecAllowedErrors = ['ContextSwitch', 'Cannot start session'];

  if (totalValue <= 1000 || !facetecAllowedErrors.includes(error)) {
    return { useFallback: false };
  }

  let onboardingApi = '/onboarding/v2/';

  if (frontendOnboardingVersion === 'minified') {
    onboardingApi = '/onboarding/v3/';
  }

  await fetch(`${Config.BaseURL}${onboardingApi}${onboardingId}/desk-reason`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      deskOrigin: 'FACETEC',
      deskReason: `Sem Facetec - ${error}`,
    }),
  });

  await fetch(`${Config.BaseURL}${onboardingApi}${onboardingId}/fallback/selfie`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  let selfieCameraRoute = 'onboarding-selfie-parcelex-camera';

  if (frontendOnboardingVersion === 'minified') {
    selfieCameraRoute = 'onboarding-minified-selfie-error';
  } if (frontendOnboardingVersion === 'v2') {
    selfieCameraRoute = 'v2-onboarding-selfie-camera-parcelex';
  }

  await router.replace({
    name: selfieCameraRoute,
    query,
  });

  return { useFallback: true };
}
